import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { CustomValidators } from 'app/_core/custom-validators';
import { EdpValidators } from 'app/_shared/edp-validators/edp-validators';
import { environment } from 'environments/environment';

export class AuthViewModel {
  isEnvLoal = environment.envName === 'local';
  isLoading = false;
  isLocal = false;
  isMessagingOrd = false;
  logInForm!: UntypedFormGroup;
  loginError = false;
  messagingProfiles: string[] = [];
  reCaptchaSiteKey = environment.reCaptchaSiteKey;
  showBloquedEmailMessage = false;
  showLoginErrorMessage = false;
  showPassword = false;
  showReCaptcha = false;
  skipAutomationRecaptcha = false;
  username!: string;

  /**
   * Form Period
   * @returns {Record<string, AbstractControl>} - An object containing the form controls for the login form.
   */
  get formControls(): Record<string, AbstractControl> {
    return this.logInForm.controls;
  }

  constructor() {
    this.createForm();
  }

  /**
   * Receive token from reCaptcha
   * @param {string} recaptchaVerifiedId - token
   */
  getToken(recaptchaVerifiedId: string): void {
    this.formControls.recaptcha.setValue(recaptchaVerifiedId);
    this.formControls.recaptcha.updateValueAndValidity();
  }

  /**
   * The function `setRecaptchaValidator` sets the validator for the 'recaptcha' field in a login form
   * based on whether it is required or not.
   * @param {boolean} required - A boolean value indicating whether the recaptcha field is required or
   * not.
   */
  setRecaptchaValidator(required: boolean): void {
    if (required) {
      this.logInForm.get('recaptcha')?.setValidators([EdpValidators.required]);
    } else {
      this.logInForm.get('recaptcha')?.setValidators(null);
    }
    this.logInForm.get('recaptcha')?.updateValueAndValidity();
  }

  /**
   * The function creates a form with various form controls and sets validators for each control.
   */
  private createForm(): void {
    this.logInForm = new UntypedFormGroup({
      username: new UntypedFormControl(
        '',
        [EdpValidators.required, CustomValidators.emailValidator, EdpValidators.notDeprecatedADEmail],
        []
      ),
      password: new UntypedFormControl('', [EdpValidators.required, EdpValidators.minLength(2)], []),
      recaptcha: new UntypedFormControl('', [EdpValidators.required], []),
    });
  }
}
